import { Layout } from "antd";
const { Footer } = Layout;

function FooterComponents() {
  return (
    <Footer style={{ textAlign: "center" }}>
      ProSoft ©{new Date().getFullYear()}
    </Footer>
  );
}

export default FooterComponents;
